import { render } from "./Linda_page2.vue?vue&type=template&id=2c26e94a&scoped=true"
import script from "./Linda_page2.vue?vue&type=script&lang=js"
export * from "./Linda_page2.vue?vue&type=script&lang=js"

import "./Linda_page2.vue?vue&type=style&index=0&id=2c26e94a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c26e94a"]])

export default __exports__